import type { Todo } from '@/api'
import { isDone } from './listView'
import type { TodoNode } from './tree'
import { formatTemporalLong } from './dates'

const TELEGRAM_USERNAME = /^@([A-Za-z0-9_]{4,32})$/

// "@name" assignees link to their Telegram profile, mirroring the backend's ATTENDEE mapping.
export function assigneeLink(assignee: string): string | null {
  const match = TELEGRAM_USERNAME.exec(assignee.trim())
  if (match) return `https://t.me/${match[1]}`
  if (/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(assignee.trim())) return `mailto:${assignee.trim()}`
  return null
}

// A markdown checklist of the todo and its subtasks, for "Copy as text" -- the same shape the
// bot's own message capture understands when pasted back into a chat.
export function todoAsText(node: TodoNode, depth = 0): string {
  const todo: Todo = node.todo
  const lines = [`${'  '.repeat(depth)}- [${isDone(todo) ? 'x' : ' '}] ${todo.summary}`]
  if (depth === 0) {
    if (todo.due) lines.push(`  Due: ${formatTemporalLong(todo.due)}`)
    if (todo.description) lines.push(...todo.description.split('\n').map((l) => `  ${l}`))
  }
  for (const child of node.children) lines.push(todoAsText(child, depth + 1))
  return lines.join('\n')
}

export function formatBytes(bytes: number | null): string {
  if (bytes === null) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}
